import React from 'react';

export const ShutterLeftFoldPostRight = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 103.22 59.39"
      width="111"
      {...props}
    >
      <g data-name="Group 83-2">
        <g data-name="Group 483">
          <path
            data-name="Rectangle 166"
            fill="#fff"
            d="M5.49.59h92.24v50.8H5.49z"
          />
          <path
            data-name="Path 2322"
            d="M4.72 51.39V.59A.69.69 0 015.49 0h92.24a.71.71 0 01.77.59v50.8c0 .32-.35.58-.77.58H5.49a.68.68 0 01-.77-.58zM96.99 1.18H6.26V50.8h90.73z"
            fill="#dcd9d5"
          />
        </g>
        <g data-name="Group 484">
          <path
            data-name="Rectangle 167"
            fill="#fff"
            d="M5.49.59h92.24v50.8H5.49z"
          />
          <path
            data-name="Path 2323"
            d="M4.72 51.39V.59A.69.69 0 015.49 0h92.24a.71.71 0 01.77.59v50.8c0 .32-.35.58-.77.58H5.49a.68.68 0 01-.77-.58zM96.99 1.18H6.26V50.8h90.73z"
            fill="#dcd9d5"
          />
        </g>
        <g data-name="Group 485" fill="#dcd9d5">
          <path data-name="Rectangle 168" d="M9.9 3.94h83.42v44.1H9.9z" />
          <path
            data-name="Path 2324"
            d="M9.89 48.62c-.42 0-.77-.26-.76-.58V3.94c0-.32.34-.58.77-.58h83.42c.42 0 .77.26.77.58V48c0 .32-.35.58-.77.58H9.89zm84.1-44.09H10.67v42.92h83.32z"
          />
        </g>
        <path
          data-name="Path 2325"
          d="M.73 51.94h101.76c.4 0 .73-.25.73-.55a.65.65 0 00-.73-.56H.73a.65.65 0 00-.73.56c-.01.3.33.55.73.55z"
          fill="#dcd9d5"
        />
      </g>
      <g data-name="Group 85">
        <g data-name="Group 498">
          <path
            data-name="Rectangle 182"
            fill="#233762"
            d="M68.45 8.37l27.79-6.03v49.49l-27.79 6.8V8.37z"
          />
          <path
            data-name="Path 2338"
            d="M96.73 52.33l-28.74 7.06V7.85l28.74-6.24zm-27.74 5.55l26.79-6.55V3.07L68.99 8.89z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499">
          <path
            data-name="Rectangle 183"
            fill="#233762"
            d="M71.47 13.03L93.5 8.18v3.57l-22.03 4.89v-3.61z"
          />
          <path
            data-name="Path 2339"
            d="M93.75 12L71.2 17v-4.24l22.55-5zm-22 4.23l21.52-4.77v-2.9L71.72 13.3z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500">
          <path
            data-name="Rectangle 184"
            fill="#233762"
            d="M71.47 16.64l22.03-4.89v3.57l-22.03 4.93v-3.61z"
          />
          <path
            data-name="Path 2340"
            d="M93.75 15.58l-22.55 5v-4.21l22.55-5zm-22 4.28l21.52-4.81v-2.92l-21.55 4.78z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501">
          <path
            data-name="Rectangle 185"
            fill="#233762"
            d="M71.47 20.25l22.03-4.93v3.56l-22.03 4.98v-3.61z"
          />
          <path
            data-name="Path 2341"
            d="M93.75 19.15l-22.55 5.1V20l22.55-5zm-22 4.33l21.52-4.86V15.7l-21.55 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502">
          <path
            data-name="Rectangle 186"
            fill="#233762"
            d="M71.47 23.89l22.03-4.98v3.57L71.47 27.5v-3.61z"
          />
          <path
            data-name="Path 2342"
            d="M93.75 22.74L71.2 27.89v-4.27l22.55-5.09zm-22 4.37l21.52-4.9v-2.92l-21.55 4.87z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503">
          <path
            data-name="Rectangle 187"
            fill="#233762"
            d="M71.47 27.5l22.03-5.02v3.56l-22.03 5.07V27.5z"
          />
          <path
            data-name="Path 2343"
            d="M93.75 26.31L71.2 31.5v-4.27l22.55-5.14zm-22 4.41l21.52-4.94v-2.92l-21.55 4.91z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504">
          <path
            data-name="Rectangle 188"
            fill="#233762"
            d="M71.47 31.11l22.03-5.07v3.57l-22.03 5.11v-3.61z"
          />
          <path
            data-name="Path 2344"
            d="M93.75 29.88L71.2 35.11v-4.27l22.55-5.18zm-22 4.45l21.52-5v-2.9l-21.55 4.95z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505">
          <path
            data-name="Rectangle 189"
            fill="#233762"
            d="M71.47 34.72l22.03-5.11v3.57l-22.03 5.15v-3.61z"
          />
          <path
            data-name="Path 2345"
            d="M93.75 33.44L71.2 38.72v-4.26l22.55-5.23zM71.72 38l21.52-5v-3l-21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506">
          <path
            data-name="Rectangle 190"
            fill="#233762"
            d="M71.47 38.33l22.03-5.15v3.57l-22.03 5.2v-3.62z"
          />
          <path
            data-name="Path 2346"
            d="M93.75 37L71.2 42.33v-4.26l22.55-5.27zm-22 4.55l21.52-5.08v-2.91l-21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507">
          <path
            data-name="Rectangle 191"
            fill="#233762"
            d="M71.47 41.95l22.03-5.2v3.56l-22.03 5.25v-3.61z"
          />
          <path
            data-name="Path 2347"
            d="M93.75 40.58L71.2 46v-4.32l22.55-5.32zm-22 4.59l21.52-5.12v-2.92l-21.55 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508">
          <path
            data-name="Rectangle 192"
            fill="#233762"
            d="M71.47 45.58l22.03-5.24v3.57L71.47 49.2v-3.62z"
          />
          <path
            data-name="Path 2348"
            d="M93.75 44.17L71.2 49.58v-4.26L93.75 40zm-22 4.64l21.52-5.17v-2.92l-21.55 5.13z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509">
          <path
            data-name="Rectangle 193"
            fill="#233762"
            d="M71.47 49.2l22.03-5.29v3.56l-22.03 5.34V49.2z"
          />
          <path
            data-name="Path 2349"
            d="M93.75 47.74L71.2 53.2v-4.27l22.55-5.41zm-22 4.68l21.52-5.21v-2.92l-21.55 5.17z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194"
          fill="#fff"
          d="M81.92 10.73l1.44-.32v39.52l-1.44.34V10.73z"
        />
      </g>
      <g data-name="Group 85-2">
        <g data-name="Group 498-2">
          <path
            data-name="Rectangle 182-2"
            fill="#233762"
            d="M34.54 8.27L6.75 2.24v49.49l27.79 6.8V8.27z"
          />
          <path
            data-name="Path 2338-2"
            d="M6.26 1.52l28.73 6.23v51.54l-28.78-7zm27.73 7.27L7.24 3v48.23l26.75 6.55z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-2">
          <path
            data-name="Rectangle 183-2"
            fill="#233762"
            d="M31.54 12.93L9.49 8.08v3.57l22.05 4.89v-3.61z"
          />
          <path
            data-name="Path 2339-2"
            d="M9.24 7.71l22.55 5V17L9.24 12zm22 5.49L9.75 8.46v2.92l21.52 4.77z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-2">
          <path
            data-name="Rectangle 184-2"
            fill="#233762"
            d="M31.54 16.54L9.49 11.65v3.57l22.05 4.93v-3.61z"
          />
          <path
            data-name="Path 2340-2"
            d="M9.24 11.27l22.55 5v4.27L9.24 15.48zm22 5.54L9.75 12v3l21.52 4.81z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-2">
          <path
            data-name="Rectangle 185-2"
            fill="#233762"
            d="M31.54 20.15L9.49 15.22v3.57l22.05 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-2"
            d="M9.24 14.84l22.55 5v4.27L9.24 19.05zm22 5.58L9.75 15.6v2.92l21.52 4.86z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-2">
          <path
            data-name="Rectangle 186-2"
            fill="#233762"
            d="M31.54 23.79L9.49 18.81v3.57l22.05 5.02v-3.61z"
          />
          <path
            data-name="Path 2342-2"
            d="M9.24 18.43l22.55 5.09v4.27L9.24 22.64zm22 5.63L9.75 19.19v2.92L31.27 27z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-2">
          <path
            data-name="Rectangle 187-2"
            fill="#233762"
            d="M31.54 27.4L9.49 22.38v3.57l22.05 5.06V27.4z"
          />
          <path
            data-name="Path 2343-2"
            d="M9.24 22l22.55 5.13v4.27L9.24 26.21zm22 5.67L9.75 22.76v2.92l21.52 4.94z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-2">
          <path
            data-name="Rectangle 188-2"
            fill="#233762"
            d="M31.54 31.01L9.49 25.95v3.56l22.05 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-2"
            d="M9.24 25.56l22.55 5.18V35L9.24 29.78zm22 5.72l-21.52-5v2.92l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-2">
          <path
            data-name="Rectangle 189-2"
            fill="#233762"
            d="M31.54 34.62L9.49 29.51v3.57l22.05 5.15v-3.61z"
          />
          <path
            data-name="Path 2345-2"
            d="M9.24 29.13l22.55 5.23v4.26L9.24 33.34zm22 5.76l-21.52-5v2.93l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-2">
          <path
            data-name="Rectangle 190-2"
            fill="#233762"
            d="M31.54 38.23L9.49 33.08v3.57l22.05 5.2v-3.62z"
          />
          <path
            data-name="Path 2346-2"
            d="M9.24 32.7L31.79 38v4.27L9.24 36.91zm22 5.8l-21.52-5v2.92l21.52 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-2">
          <path
            data-name="Rectangle 191-2"
            fill="#233762"
            d="M31.54 41.85l-22.05-5.2v3.56l22.05 5.25v-3.61z"
          />
          <path
            data-name="Path 2347-2"
            d="M9.24 36.27l22.55 5.31v4.27L9.24 40.48zm22 5.84L9.75 37v3l21.52 5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-2">
          <path
            data-name="Rectangle 192-2"
            fill="#233762"
            d="M31.54 45.48L9.49 40.24v3.57l22.05 5.29v-3.62z"
          />
          <path
            data-name="Path 2348-2"
            d="M9.24 39.86l22.55 5.36v4.27L9.24 44.07zm22 5.89L9.75 40.62v2.92l21.52 5.17z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-2">
          <path
            data-name="Rectangle 193-2"
            fill="#233762"
            d="M31.54 49.1L9.49 43.81v3.57l22.05 5.33V49.1z"
          />
          <path
            data-name="Path 2349-2"
            d="M9.24 43.42l22.55 5.41v4.27L9.24 47.64zm22 5.94L9.75 44.19v2.92l21.52 5.21z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-2"
          fill="#fff"
          d="M21.07 10.63l-1.44-.32v39.52l1.44.35V10.63z"
        />
      </g>
      <g data-name="Group 85-3">
        <g data-name="Group 498-3">
          <path
            data-name="Rectangle 182-3"
            fill="#233762"
            d="M33.94 8.27l27.79-6.03v49.49l-27.79 6.8V8.27z"
          />
          <path
            data-name="Path 2338-3"
            d="M62.2 52.24l-28.77 7V7.75L62.2 1.52zm-27.76 5.54l26.79-6.55V3L34.44 8.79z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-3">
          <path
            data-name="Rectangle 183-3"
            fill="#233762"
            d="M36.94 12.93l22.04-4.85v3.57l-22.04 4.89v-3.61z"
          />
          <path
            data-name="Path 2339-3"
            d="M59.22 11.92l-22.55 5v-4.26l22.56-4.95zm-22 4.23l21.53-4.77V8.46L37.19 13.2z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-3">
          <path
            data-name="Rectangle 184-3"
            fill="#233762"
            d="M36.94 16.54l22.04-4.89v3.57l-22.04 4.93v-3.61z"
          />
          <path
            data-name="Path 2340-3"
            d="M59.22 15.48l-22.55 5.06v-4.27l22.56-5zm-22 4.28L58.72 15v-3l-21.53 4.81z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-3">
          <path
            data-name="Rectangle 185-3"
            fill="#233762"
            d="M36.94 20.15l22.04-4.93v3.57l-22.04 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-3"
            d="M59.22 19.05l-22.55 5.1v-4.27l22.56-5zm-22 4.33l21.53-4.86V15.6l-21.56 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-3">
          <path
            data-name="Rectangle 186-3"
            fill="#233762"
            d="M36.94 23.79l22.04-4.98v3.57L36.94 27.4v-3.61z"
          />
          <path
            data-name="Path 2342-3"
            d="M59.22 22.64l-22.55 5.15v-4.27l22.56-5.09zM37.19 27l21.53-4.9v-2.91l-21.53 4.87z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-3">
          <path
            data-name="Rectangle 187-3"
            fill="#233762"
            d="M36.94 27.4l22.04-5.02v3.57l-22.04 5.06V27.4z"
          />
          <path
            data-name="Path 2343-3"
            d="M59.22 26.21L36.67 31.4v-4.27L59.23 22zm-22 4.41l21.53-4.94v-2.92l-21.56 4.91z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-3">
          <path
            data-name="Rectangle 188-3"
            fill="#233762"
            d="M36.94 31.01l22.04-5.06v3.56l-22.04 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-3"
            d="M59.22 29.78L36.67 35v-4.26l22.56-5.18zm-22 4.46l21.53-5v-2.91l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-3">
          <path
            data-name="Rectangle 189-3"
            fill="#233762"
            d="M36.94 34.62l22.04-5.11v3.57l-22.04 5.15v-3.61z"
          />
          <path
            data-name="Path 2345-3"
            d="M59.22 33.34l-22.55 5.28v-4.26l22.56-5.23zm-22 4.51l21.53-5v-3l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-3">
          <path
            data-name="Rectangle 190-3"
            fill="#233762"
            d="M36.94 38.23l22.04-5.15v3.57l-22.04 5.2v-3.62z"
          />
          <path
            data-name="Path 2346-3"
            d="M59.22 36.91l-22.55 5.33V38l22.56-5.3zm-22 4.55l21.53-5.08v-2.92l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-3">
          <path
            data-name="Rectangle 191-3"
            fill="#233762"
            d="M36.94 41.85l22.04-5.2v3.56l-22.04 5.25v-3.61z"
          />
          <path
            data-name="Path 2347-3"
            d="M59.22 40.48l-22.55 5.37v-4.27l22.56-5.31zm-22 4.59L58.72 40v-3l-21.53 5.11z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-3">
          <path
            data-name="Rectangle 192-3"
            fill="#233762"
            d="M36.94 45.48l22.04-5.24v3.57L36.94 49.1v-3.62z"
          />
          <path
            data-name="Path 2348-3"
            d="M59.22 44.07l-22.55 5.42v-4.27l22.56-5.36zm-22 4.64l21.53-5.17v-2.92l-21.56 5.13z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-3">
          <path
            data-name="Rectangle 193-3"
            fill="#233762"
            d="M36.94 49.1l22.04-5.29v3.57l-22.04 5.33V49.1z"
          />
          <path
            data-name="Path 2349-3"
            d="M59.22 47.64L36.67 53.1v-4.27l22.56-5.41zm-22 4.68l21.53-5.21v-2.92l-21.56 5.17z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-3"
          fill="#fff"
          d="M47.4 10.63l1.44-.32v39.52l-1.44.35V10.63z"
        />
      </g>
      <path fill="#233762" d="M66.6 3.42h1.36v45.21H66.6z" />
    </svg>
  );
};
